




















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import ResearchLine from "@/models/coding/researchLine/researchLine.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from '@/enums/PermissionValue';
@Component
export default class ResearchLineTable extends GenericBTable<ResearchLine> {
  isLoading = false;
  created() {
    this.permissionValue = PermissionValue.CODIFICACIONES;
    this.tableConfig.controller = "ResearchLines";
      this.tableConfig.whereParams = `fieldAreaId eq ${
      this.$route.params.fieldAreaId
    }`; 
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.name", false);
    let code = new BTableColumn("code", "table.code", true);
    this.tableConfig.insertColumns(name,code);
    this.tableConfig.actions.customTemplate = false;
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
  
}
